import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { Box, Flex, Text, Group, Button, Pagination, Modal, Drawer, Badge } from '@mantine/core'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { getCustomMenuList, deleteCustomMenu } from '../../../../services/custom-menu'
import { IconPlus } from '@tabler/icons-react'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import TableCustomMenu from '../../../../component/pages/CustomMenu/TableCustomMenu'
import FormCustomMenu from '../../../../component/pages/CustomMenu/FormCustomMenu'
import FormFilterMenu from '../../../../component/pages/CustomMenu/FormFilterMenu'
import { useDebouncedCallback } from '@mantine/hooks'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'

const defaultParameter = {
  'page[num]': 1,
  'page[limit]': 10,
  sort: '-id',
  include: 'categories,creator,updater',
  'fields[user]' : 'name'
}

const labelTable = [
  {
    label: 'ID',
    width: 30
  },
  {
    label: 'Menu Name',
    width: 350
  },
  {
    label: 'Image',
    width: 'auto'
  },
  {
    label: 'Target',
    width: 300
  },
  {
    label: 'Category',
    width: 'auto'
  },
  {
    label: 'Type',
    width: 'auto'
  },
  {
    label: 'Country Signup',
    width: 'auto'
  },
  {
    label: 'Priority',
    width: 'auto'
  },
  {
    label: 'Created By',
    width: 'auto'
  },
  {
    label: 'Updated By',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const CustomMenu = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [params, setParams] = useState(defaultParameter)
  const [customMenuList, setCustomMenuList] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [openModalFilter, setOpenModalFilter] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Promotions',
      route: null
    },
    {
      label: 'Custom Menu Mobile',
      route: null
    },
  ]

  const handleGetCustomMenuList = useDebouncedCallback(async () => {
    setLoading(true)
    try {
      const response = await getCustomMenuList(params)
      if (response.success) {
        const dataCustomMenu = response.data
        const pickIncludedCreator = response.included.creator || []
        const pickIncludedUpdater = response.included.updater || []

        const countData = response.meta.pagination.total

        const getDataUser = (userId, included) => {
          let data = null
          const findUser = included[userId]
          if (findUser) {
            data = {
              id: findUser.attributes.id,
              name: findUser.attributes.name
            }
          }
          return data
        }

        const remapData = dataCustomMenu.map((val) => {
          return {
            ...val.attributes,
            creator: val.attributes.created_by !== null ? getDataUser(val.attributes.created_by, pickIncludedCreator) : null,
            updater: val.attributes.updated_by !== null ? getDataUser(val.attributes.updated_by, pickIncludedUpdater) : null,
          }
        })

        setCustomMenuList(remapData)
        setTotalData(countData)
      } else {
        setCustomMenuList([])
        setTotalData(0)
      }
      
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }, 500)

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetCustomMenuList()
    // eslint-disable-next-line
  }, [params])

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
    delete: (val) => {
      modalDeleteData('Custom Menu', val.id, val.menu_name, deleteCustomMenu, handleGetCustomMenuList)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const handleApplyFilter = (params) => {
    setParams((oldVal) => ({ ...oldVal, ...params }))
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  const onCloseFormFilter = () => {
    setOpenModalFilter(false)
  }

   const mappingFilterCustomMenu = (parameter) => {
    if (parameter['filter[menu_type][is]']) {
      return (
        <Box>
          <Group gap='sm' align='center' mb={12}>
            {parameter['filter[menu_type][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Menu Type: {parameter['filter[menu_type][is]']}</Badge> : ''}
          </Group>
          <Group align='center' gap='sm'>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setOpenModalFilter(true)}>Modify Filter</Button>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setParams(defaultParameter)}>Clear Filter</Button>
          </Group>
        </Box>
      )
    }
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>Custom Menu Mobile</Text>
            <Group gap='sm' align='center'>
              <Button size='xs' variant="outline" onClick={() => setOpenModalFilter(true)}>Filter</Button>
              <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add New Menu</Button>
            </Group>
          </Flex>
        </Box>
        {mappingFilterCustomMenu(params)}
        <Box my={30}>
          {loading ? <LoadingData /> : customMenuList.length > 0 ? <TableCustomMenu label={labelTable} data={customMenuList} actionMethod={handleAction} /> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} value={params['page[num]']} total={totalData > 0 ? Math.ceil(totalData / params['page[limit]']) : totalData} />
        </Flex>
        <Drawer position='right' title='Filter Brand' opened={openModalFilter} onClose={onCloseFormFilter} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
          <FormFilterMenu paramsCustomMenu={params} applyFilter={handleApplyFilter} onClose={onCloseFormFilter} />
        </Drawer>
        <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>{detailData === null ? 'Add' : 'Update'} Custom Menu</Text>} withCloseButton={false}>
          <FormCustomMenu dataMenu={detailData} onCloseForm={onCloseModalForm} reloadList={handleGetCustomMenuList} />
        </Modal>
      </Box>
    </AuthLayout>
  )
}

export default CustomMenu